export const XundaStateAction = {
  SET_FXD_POOL: 'SET_FXD_POOL',
};
